import { apiPaths } from '@/services/api/paths';
import { TMemberCareMemberObservation } from '@/types/MemberCare.types';
import { api, TCustomAxiosResponse } from '..';

export const getObservationsForMemberCareMember = async (
  memberId: string,
): Promise<TCustomAxiosResponse<TMemberCareMemberObservation[]>> => {
  const { data: response } = await api.get<TCustomAxiosResponse<TMemberCareMemberObservation[]>>(
    apiPaths.observations.forMember(memberId),
  );
  return response;
};

export const createObservationForMemberCareMember = async (content: string, memberId: string): Promise<string> => {
  const { data } = await api.post(apiPaths.observations.root, { content, userId: memberId });

  const result = data.data;

  return result;
};

export const editObservation = async (observationId: string, newContent: string): Promise<string> => {
  const { data } = await api.put(apiPaths.observations.byId(observationId), { content: newContent });

  const result = data.data;

  return result;
};

export const deleteObservation = async (observationId: string): Promise<string> => {
  const { data } = await api.delete(apiPaths.observations.byId(observationId));

  const result = data.data;

  return result;
};
